<template>
    <has-universe 
        :universe="universe"         
        toggle
    >
        <v-btn 
            :to="`/ui/universe/${universe}/settings`"
            class="px-6"
            text
            large
            color="deep-purple"
        >
            Details
        </v-btn>
    </has-universe>
</template>
<script>
export default {
    name: 'UniverseEditButton',
    props: {
        universe: String,        
    },    
    computed: {
    },
}
</script>
